const defaultState = {
  root: {},
  services: [],
  testimonials: [],
  portfolio: [],
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case "SET_WEBSITE_ROOT":
      return { ...state, root: action.root }
    case "SET_WEBSITE_SERVICES":
      return { ...state, services: action.services }
    case "SET_WEBSITE_TESTIMONIALS":
      return { ...state, testimonials: action.testimonials }
    case "SET_WEBSITE_PORTFOLIO":
      return { ...state, portfolio: action.portfolio }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/website.js